import React from 'react';
import { PS } from '../theme';

/** Full-screen column for sub-pages (detail/chat/etc). No bottom tab. */
export default function Screen({ children, bg = PS.page }) {
  return (
    <div className="ps-shell">
      <div className="ps-col" style={{ background: bg, fontFamily: PS.fontUI, color: PS.text }}>
        {children}
      </div>
    </div>
  );
}
